(function () {
  'use strict';

  // Geo detection is now handled via the saved address (shopaleena_address in localStorage)
  // set by the address picker after the customer pins their location on the map.
  // This file is kept as a stub so existing script tags don't break.
  window.ShopaleenaGeo = {
    get: function () { return Promise.resolve(null); }
  };
})();
